module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"The video call was completed, but the recording was not saved due to the lack of video and audio materials."}}')
  delete Component.options._Ctor
}
